module.exports = __webpack_public_path__ + "media/images/countrysquared/mm-4a98c491a7eba678815d064cabf27a38.svg";